import request from '@/utils/http.js';
import qs from 'qs';


const normalizeToJsonString = ( value ) => {
    if ( value === undefined || value === null ) return value;
    if ( typeof value === "string" ) return value;
    return JSON.stringify( value );
};

const normalizeSignalPreviewPayload = ( data = {} ) => ( {
    ...data,
    buyPool: normalizeToJsonString( data?.buyPool ),
    sellPool: normalizeToJsonString( data?.sellPool ),
} );

// 获取预览信号池
// POST /Strategyt0/getSignalPreview
// 入参：buyPool/sellPool（数组对象或 JSON 字符串，至少传一个）
export function getSignalPreview ( data = {} ) {
    return request( {
        url: `${ window.config.api_v1 }/Strategyt0/getSignalPreview`,
        method: "post",
        data: qs.stringify( normalizeSignalPreviewPayload( data ) ),
        type: "json",
        showLoading: false,
    } );
}

// 获取事件列表
// GET /Strategyt0/getEventList
// 入参：qid（可选，不传自动生成）
export function getEventList ( params = {} ) {
    return request( {
        url: `${ window.config.api_v1 }/Strategyt0/getEventList`,
        method: "get",
        params,
        type: "json",
    } );
}

// 获取事件详情（GET）
// GET /Strategyt0/getEventDetail
// 入参：eventId（必传）、qid（可选，不传自动生成）
export function getEventDetail ( params = {} ) {
    return request( {
        url: `${ window.config.api_v1 }/Strategyt0/getEventDetail`,
        method: "get",
        params,
        type: "json",
    } );
}

// 获取事件详情（POST）
// POST /Strategyt0/getEventDetail
// 入参：eventId（必传）、qid（可选，不传自动生成）
export function getEventDetailPost ( data = {} ) {
    return request( {
        url: `${ window.config.api_v1 }/Strategyt0/getEventDetail`,
        method: "post",
        data: qs.stringify( data ),
        type: "json",
        showLoading: false,
    } );
}

// 获取事件关联股票池（GET）
// GET /Strategyt0/getEventPool
// 入参：eventId（必传）、qid（可选，不传自动生成）
export function getEventPool ( params = {} ) {
    return request( {
        url: `${ window.config.api_v1 }/Strategyt0/getEventPool`,
        method: "get",
        params,
        type: "json",
    } );
}

// 获取事件关联股票池（POST）
// POST /Strategyt0/getEventPool
// 入参：eventId（必传）、qid（可选，不传自动生成）
export function getEventPoolPost ( data = {} ) {
    return request( {
        url: `${ window.config.api_v1 }/Strategyt0/getEventPool`,
        method: "post",
        data: qs.stringify( data ),
        type: "json",
        showLoading: false,
    } );
}

// 事件表达式选股（POST）
// POST /Strategyt0/getEventStocks
// 入参：expression（必传）、qid（可选，不传自动生成）
export function getEventStocks ( data = {} ) {
    return request( {
        url: `${ window.config.api_v1 }/Strategyt0/getEventStocks`,
        method: "post",
        data: qs.stringify( data ),
        type: "json",
        showLoading: false,
    } );
}

// 事件表达式选股（GET）
// GET /Strategyt0/getEventStocks
// 入参：expression（必传）、qid（可选，不传自动生成）
export function getEventStocksByGet ( params = {} ) {
    return request( {
        url: `${ window.config.api_v1 }/Strategyt0/getEventStocks`,
        method: "get",
        params,
        type: "json",
    } );
}

const normalizeStrategyPayload = ( payload = {} ) => {
    if ( payload && Object.prototype.hasOwnProperty.call( payload, "data" ) ) {
        // 方式一：data 作为 JSON 字符串传入
        return {
            ...payload,
            data: normalizeToJsonString( payload.data ),
        };
    }
    // 方式二：直接以表单字段传入，buyPool/sellPool 自动转为 JSON 字符串
    return {
        ...payload,
        buyPool: normalizeToJsonString( payload.buyPool ),
        sellPool: normalizeToJsonString( payload.sellPool ),
    };
};

// 创建策略
// POST /Strategyt0/createStrategy
// 入参：方式一 data（JSON 字符串）或方式二 直接传表单字段（buyPool/sellPool 会自动转为 JSON 字符串）
// 自动补齐：userId（未传则使用当前登录用户）
export function createStrategy ( data = {} ) {
    return request( {
        url: `${ window.config.api_v1 }/Strategyt0/createStrategy`,
        method: "post",
        data: qs.stringify( normalizeStrategyPayload( data ) ),
        type: "json",
        showLoading: false,
    } );
}

// 更新策略
// POST /Strategyt0/updateStrategy
// 入参：同 createStrategy，必须包含 id（兼容 strategyId，Controller 会自动转换为 id）
// 自动补齐：userId（未传则使用当前登录用户）
export function updateStrategy ( data = {} ) {
    return request( {
        url: `${ window.config.api_v1 }/Strategyt0/updateStrategy`,
        method: "post",
        data: qs.stringify( normalizeStrategyPayload( data ) ),
        type: "json",
        showLoading: false,
    } );
}

// 查询策略列表
// GET /Strategyt0/getStrategyList
// 无需额外入参（使用 Session userId 作为查询用户）
export function getStrategyList ( params = {} ) {
    return request( {
        url: `${ window.config.api_v1 }/Strategyt0/getStrategyList`,
        method: "get",
        params,
        type: "json",
    } );
}

// 查询策略详情（GET）
// GET /Strategyt0/getStrategyDetail
// 入参：strategyId
export function getStrategyDetail ( params = {} ) {
    return request( {
        url: `${ window.config.api_v1 }/Strategyt0/getStrategyDetail`,
        method: "get",
        params,
        type: "json",
    } );
}

// 查询策略详情（POST）
// POST /Strategyt0/getStrategyDetail
// 入参：strategyId
export function getStrategyDetailPost ( data = {} ) {
    return request( {
        url: `${ window.config.api_v1 }/Strategyt0/getStrategyDetail`,
        method: "post",
        data: qs.stringify( data ),
        type: "json",
        showLoading: false,
    } );
}

// 删除策略（GET）
// GET /Strategyt0/deleteStrategy
// 入参：strategyId
export function deleteStrategy ( params = {} ) {
    return request( {
        url: `${ window.config.api_v1 }/Strategyt0/deleteStrategy`,
        method: "get",
        params,
        type: "json",
    } );
}

// 删除策略（POST）
// POST /Strategyt0/deleteStrategy
// 入参：strategyId
export function deleteStrategyPost ( data = {} ) {
    return request( {
        url: `${ window.config.api_v1 }/Strategyt0/deleteStrategy`,
        method: "post",
        data: qs.stringify( data ),
        type: "json",
        showLoading: false,
    } );
}

// 置顶/取消置顶策略
// POST /Strategyt0/pinStrategy
// 入参：strategyId, is_pinned（1-置顶, 0-取消置顶）
export function pinStrategy ( data = {} ) {
    return request( {
        url: `${ window.config.api_v1 }/Strategyt0/pinStrategy`,
        method: "post",
        data: qs.stringify( data ),
        type: "json",
        showLoading: false,
    } );
}

// 查询信号列表
// POST /Strategyt0/getSignalList
// 入参：方式一 data（JSON 字符串）或方式二 直接传表单字段
// 自动补齐：userId（未传则使用当前登录用户）
export function getSignalList ( data = {} ) {
    return request( {
        url: `${ window.config.api_v1 }/Strategyt0/getSignalList`,
        method: "post",
        data: qs.stringify( normalizeStrategyPayload( data ) ),
        type: "json",
        showLoading: false,
    } );
}
